<template>
    <b-dropdown
        aria-role="list"
        aria-haspopup="true"
        position="is-bottom-left"
        :append-to-body="true"
        :disabled="disabled"
    >
        <template #trigger>
            <i class="is-clickable mt-1 ml-5 material-icons"> more_vert </i>
        </template>

        <!-- MANUAL MENU -->
        <b-dropdown-item @click="onEdit()" v-if="!isAutomatic" class="is-flex is-align-items-center" aria-role="listitem">
                <i class="material-icons is-size-5 icon-clear mr-2"> edit </i>
                Editar
        </b-dropdown-item>
        <b-dropdown-item @click="onShowConfirm()" v-if="!isAutomatic" class="is-flex is-align-items-center" aria-role="listitem">
                <i class="material-icons is-size-5 icon-clear mr-2"> delete </i>
                Eliminar
        </b-dropdown-item>

        <!-- AUTOMATIC MENU -->
        <b-dropdown-item
            class="is-flex is-align-items-center"
            aria-role="listitem"
            @click="onShowConfirm()"
            v-if="isAutomatic"
        >
            <i class="material-icons is-size-5 icon-clear mr-2"> power_off </i>
            Desconectar
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
export default {
    name: "DropdownMenu",
    props: {
        itemIndex: {
            type: Number,
            default: null
        },
        isAutomatic: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onShowConfirm: function(){this.$emit('on-show-confirm',this.itemIndex)},
        onEdit: function(){this.$emit('on-edit',this.itemIndex)}
    },
    
};
</script>